import { Autorenew } from '@mui/icons-material';
import { Button, ListItemIcon, MenuItem, Typography } from '@mui/material';
import MaterialReactTable from 'material-react-table';
import React, { useEffect, useMemo, useState } from 'react'
import { getData } from '../../../services/library';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import PeopleIcon from "@mui/icons-material/People";
import Navbar from '../../Navbar';

function ListaPreciosEspeciales() {
const [preciosEspeciales, setPreciosEspeciales] = useState([{}]); //Estado para guardar las direcciones de entrega
  const [addPrecio, setAddPrecio] = useState(false)
  const [actualizar, setActualizar] = useState(false);
  const [actualizarParticular, setActualizarParticular] = useState(false)
  const [verHistorial, setVerHistorial] = useState(false)
  const [tabla, setTabla] = useState(true)
  const [row, setRow] = useState()
  const obtenerPrecios = () => {
    getData(
      "/envasado_clientes/listapreciosespecial",
      setPreciosEspeciales
    );
  };

  useEffect(() => {
    obtenerPrecios();
  }, []);  

  const handleVerHistorial = () =>{
    setTabla(false)
    setVerHistorial(true)
  }

  const handleCloseHistorial = () =>{
    setVerHistorial(false)
    setTabla(true)
  }

  const columns = useMemo(
    () => [
        {
        accessorKey: "nombre_cliente", //access nested data with dot notation
        header: "Cliente",
        size: 150,
        muiTableBodyCellProps: {
          align: "left",
        },
      },
      {
        accessorKey: "nombre_producto", //access nested data with dot notation
        header: "Producto",
        size: 150,
        muiTableBodyCellProps: {
          align: "left",
        },
      },
      {
        accessorKey: "precio_minimo", //access nested data with dot notation
        header: "Precio",
        // size: 150,
        muiTableBodyCellProps: {
          align: "center",
        },
      },

    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: {
      pageSize: 10,
      pageIndex: 0,
    },
    // grouping: ["nombre_cliente"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
    },
  };
  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };
  return (
    <div>
        <Navbar/>
      {tabla && (
      <MaterialReactTable
        columns={columns}
        enableTopToolbar={true}
        data={preciosEspeciales ?? []}
        enableColumnFilterModes={false}
        enableColumnOrdering={false}
        enableGrouping={false}
        localization={customLocalization}
        enablePinning={true}
        enableRowActions={true}
        initialState={initialState}
        enableRowSelection={false}
        positionActionsColumn={"last"}
        enableHiding={false}
        muiTableHeadCellProps={tableHeadCellProps}
        positionExpandColumn={"first"}
        //   renderDetailPanel={({ row }) => (
        //     <DetalleDireccion
        //       direccion={row.original}
        //       actulizar={obtenerDirecciones}
        //       cliente={dataCliente}
        //     />
        //   )}
        enableExpandAll={false}
        muiTableBodyCellProps={({ row }) => ({
          align: "center",
          sx: {
            backgroundColor: "#ffffff",
            color: "black",
            borderColor: "#FDFEFE",
          },
        })}
        renderTopToolbarCustomActions={(row, table) => (
          <>
            {/* <Button
              variant="contained"
              color="primary"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => {
                setAddPrecio(true);
              }}
            >
              Nuevo Precio
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Autorenew />}
              onClick={() => {
                setActualizar(true);
              }}
            >
              Actualizar Precios
            </Button> */}
            <Typography variant="poster" fontSize={26}>
              <PeopleIcon sx={{ fontSize: 20 }} />
              Precios especiales
            </Typography>
            {/* <Button
              variant="contained"
              color="primary"
              startIcon={<HistoryIcon />}
              onClick={handleVerHistorial}
            >
              Historial
            </Button> */}
          </>
        )}
        enableColumnActions={false}
        enableColumnFilters={false} //Quita filtros por columna
        displayColumnDefOptions={displayColumnDefOptions}
        enableDensityToggle={false}
        renderRowActionMenuItems={({ closeMenu, row, index }) => [
          <MenuItem
            key={index}
            onClick={() => {
              setRow(row.original);
              setActualizarParticular(true);
              closeMenu();
            }}
            sx={{ m: 0 }}
          >
            <ListItemIcon>
              <Autorenew color="primary" />
            </ListItemIcon>
            Actualizar Precio
          </MenuItem>,
        ]}
      />
      )}
      {/* {addPrecio && (
        <AddPrecioEspecial
            open={addPrecio}
            setOpen={setAddPrecio}
            cliente={dataCliente}
            actualizar={obtenerPrecios}
            precioEspecial={precioEspecial}
        />
      )} */}
      {/* {actualizar && (
        <ActualizarPrecioGeneral
          open={actualizar}
          setOpen={setActualizar}
          cliente={dataCliente}
          actualizar={obtenerPrecios}
          precioEspecial={precioEspecial}
        />
      )}
      {actualizarParticular && (
        <ActualizarEspecialParticular
          open={actualizarParticular}
          setOpen={setActualizarParticular}
          onClose={()=>{
            setActualizarParticular(false)
            obtenerPrecios()
          }}
          row={row}
        />
      )} */}

    </div>
  );
}

export default ListaPreciosEspeciales